'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const useMediaQuery = (query, t0) => {
  const $ = _c(6);
  const initialState = t0 === undefined ? false : t0;
  const [matches, setMatches] = useState(initialState);
  let t1;
  let t2;
  if ($[0] !== query) {
    t1 = () => {
      if (typeof window !== "undefined" && window) {
        const media = window.matchMedia(query);
        setMatches(media.matches);
      }
    };
    t2 = [query];
    $[0] = query;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== query) {
    t3 = () => {
      const media_0 = window.matchMedia(query);
      const listener = () => setMatches(media_0.matches);
      window.addEventListener("resize", listener);
      return () => window.removeEventListener("resize", listener);
    };
    t4 = [query];
    $[3] = query;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  return matches;
};
export default useMediaQuery;